// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1sZJV","title":"Images90_title__72G0Y","images":"Images90_images__1L_SV"};